"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Row = void 0;
var react_1 = require("@chakra-ui/react");
var react_2 = __importDefault(require("react"));
var Row = function (_a) {
    var rowData = _a.rowData, children = _a.children;
    return (react_2.default.createElement(react_1.Box, { className: "row gutter-10 " + (rowData.class ? rowData.class : ""), mx: "auto", css: rowData.style }, children));
};
exports.Row = Row;
